import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 py-4 md:py-8" }
const _hoisted_2 = { class: "grid flex-1 items-start gap-4 sm:py-0 md:gap-8 max-w-[85rem] mx-auto w-full px-4 sm:px-6" }
const _hoisted_3 = {
  key: 0,
  class: "relative"
}
const _hoisted_4 = {
  key: 0,
  class: "relative"
}
const _hoisted_5 = { class: "flex flex-wrap gap-6 pb-4 justify-center" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-16 px-4"
}
const _hoisted_8 = { class: "bg-white/5 rounded-full p-6 mb-6" }

import Card from '@/components/ui/card/Card.vue';
import { useAxios } from '@/composables/useAxios';
import { Course } from '@/interfaces/Course';
import CourseArtwork from '@/views/home/components/CourseArtwork.vue';
import { Separator } from 'radix-vue';
import { onMounted, ref } from 'vue';
import { Pagination as IPagination } from '@/interfaces/Pagination'
import CourseSkeleton from '@/views/courses/components/CourseSkeleton.vue';
import PaginationApi from '@/components/ui/pagination/PaginationApi.vue';
import router from '@/router';
import { useCourse } from '@/composables/useCourse';
import { BookOpenIcon, SearchIcon } from 'lucide-vue-next';


export default /*@__PURE__*/_defineComponent({
  __name: 'MyCoursesView',
  setup(__props) {

const axios = useAxios()
const courses = ref<IPagination<Course>>()
const { redirectToCurrentLesson } = useCourse()

function getCourses(page = 1) {
  axios.get('/courses', { params: { page, mine: true, owner: false } })
    .then((res) => {
      courses.value = res.data
    })
}

function navigateToExplore() {
  router.push({ name: 'courses.all' }); // Ajuste para a rota correta de exploração de cursos
}

onMounted(() => {
  getCourses()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _createVNode(Card, { class: "p-6" }, {
        default: _withCtx(() => [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex items-center justify-between" }, [
            _createElementVNode("div", { class: "space-y-1" }, [
              _createElementVNode("h2", { class: "text-[1.1rem] font-semibold tracking-tight" }, " Meus cursos "),
              _createElementVNode("p", { class: "text-sm text-muted-foreground" }, " Explore todos os cursos que você adquiriu e comece sua jornada de aprendizado! ")
            ])
          ], -1)),
          _createVNode(_unref(Separator), { class: "my-4" }),
          (courses.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (courses.value?.data && courses.value?.data.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courses.value.data, (course) => {
                          return (_openBlock(), _createElementBlock("a", {
                            class: "cursor-pointer",
                            onClick: ($event: any) => (_unref(redirectToCurrentLesson)(course)),
                            key: course.title
                          }, [
                            _createVNode(CourseArtwork, {
                              course: course,
                              class: "w-full sm:w-[250px]",
                              "aspect-ratio": "portrait",
                              width: 250,
                              height: 330
                            }, null, 8, ["course"])
                          ], 8, _hoisted_6))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_unref(BookOpenIcon), { class: "h-12 w-12" })
                      ]),
                      _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "text-xl font-semibold mb-2 text-center" }, "Nenhum curso encontrado", -1)),
                      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-muted-foreground text-center max-w-md mb-8 text-sm" }, " Parece que você ainda não adquiriu nenhum curso. Explore nossa plataforma para descobrir conteúdos incríveis para sua jornada de aprendizado. ", -1)),
                      _createElementVNode("button", {
                        onClick: navigateToExplore,
                        class: "text-white font-medium inline-flex items-center justify-center rounded-md bg-gradient-to-r from-blue-500 to-purple-600 px-6 py-3 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                      }, [
                        _createVNode(_unref(SearchIcon), { class: "mr-2 h-4 w-4" }),
                        _cache[0] || (_cache[0] = _createTextVNode(" Explorar cursos disponíveis "))
                      ])
                    ]))
              ]))
            : (_openBlock(), _createBlock(CourseSkeleton, { key: 1 })),
          (courses.value && (courses.value?.pagination.total ?? 0) > 1)
            ? (_openBlock(), _createBlock(PaginationApi, {
                key: 2,
                data: courses.value.pagination,
                paginate: (page) => { courses.value = undefined; getCourses(page) }
              }, null, 8, ["data", "paginate"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})